var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataAggregation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9987 22.5C24.2079 22.5 25.9987 20.7091 25.9987 18.5C25.9987 16.2909 24.2079 14.5 21.9987 14.5C19.7896 14.5 17.9987 16.2909 17.9987 18.5C17.9987 20.7091 19.7896 22.5 21.9987 22.5Z",
    fill: "#0B0B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3321 23.8333C32.8048 23.8333 33.9987 22.6394 33.9987 21.1667C33.9987 19.6939 32.8048 18.5 31.3321 18.5C29.8593 18.5 28.6654 19.6939 28.6654 21.1667C28.6654 22.6394 29.8593 23.8333 31.3321 23.8333Z",
    fill: "#0B0B17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3321 14.5C30.4366 14.5 31.3321 13.6046 31.3321 12.5C31.3321 11.3954 30.4366 10.5 29.3321 10.5C28.2275 10.5 27.3321 11.3954 27.3321 12.5C27.3321 13.6046 28.2275 14.5 29.3321 14.5Z",
    fill: "#0B0B17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6654 23.8333C11.1926 23.8333 9.99873 22.6394 9.99873 21.1667C9.99873 19.6939 11.1926 18.5 12.6654 18.5C14.1382 18.5 15.3321 19.6939 15.3321 21.1667C15.3321 22.6394 14.1382 23.8333 12.6654 23.8333Z",
    fill: "#0B0B17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6654 14.5C13.5608 14.5 12.6654 13.6046 12.6654 12.5C12.6654 11.3954 13.5608 10.5 14.6654 10.5C15.77 10.5 16.6654 11.3954 16.6654 12.5C16.6654 13.6046 15.77 14.5 14.6654 14.5Z",
    fill: "#0B0B17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6913 24.0684C21.5544 23.8958 22.4431 23.8958 23.3062 24.0684L26.5283 24.7128C27.3337 24.8739 28.0375 25.2682 28.5796 25.8138L29.6232 25.5529C30.7578 25.2692 31.947 25.289 33.0716 25.6103L33.5747 25.7541C35.4226 26.282 36.6338 28.0495 36.4593 29.9634L36.2557 32.1965C36.0679 34.2564 34.3406 35.8333 32.2722 35.8333H11.7252C9.65685 35.8333 7.92959 34.2564 7.74177 32.1965L7.53816 29.9634C7.36365 28.0495 8.57488 26.282 10.4227 25.7541L10.9259 25.6103C12.0504 25.289 13.2397 25.2692 14.3743 25.5529L15.418 25.8138C15.9601 25.2682 16.6638 24.8739 17.4693 24.7128L20.6913 24.0684ZM14.2693 28.2754L13.7275 28.1399C13.0468 27.9697 12.3332 27.9816 11.6585 28.1744L11.1553 28.3181C10.5394 28.4941 10.1356 29.0833 10.1938 29.7212L10.3974 31.9544C10.46 32.641 11.0358 33.1667 11.7252 33.1667H14.8389C14.7392 32.8841 14.67 32.5864 14.6355 32.2771L14.2784 29.079C14.2481 28.8072 14.2458 28.5383 14.2693 28.2754ZM18.6108 33.1667H25.3868C26.0659 33.1667 26.6365 32.6562 26.7119 31.9813L27.0689 28.7831C27.1457 28.0955 26.6838 27.4634 26.0053 27.3277L22.7832 26.6833C22.2654 26.5797 21.7322 26.5797 21.2143 26.6833L17.9922 27.3277C17.3138 27.4634 16.8519 28.0955 16.9286 28.7831L17.2857 31.9813C17.361 32.6562 17.9317 33.1667 18.6108 33.1667ZM29.7191 29.079C29.7495 28.8072 29.7518 28.5383 29.7282 28.2753L30.2699 28.1399C30.9507 27.9697 31.6642 27.9816 32.339 28.1744L32.8421 28.3181C33.4581 28.4941 33.8618 29.0833 33.8037 29.7212L33.6 31.9544C33.5374 32.641 32.9617 33.1667 32.2722 33.1667H29.1586C29.2584 32.8841 29.3275 32.5864 29.3621 32.2772L29.7191 29.079Z",
    fill: "#0B0B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAggregation);
export default __webpack_public_path__ + "static/media/data-aggregation.617244bba586ff19e0f1bed215581301.svg";
export { ForwardRef as ReactComponent };